<template>
  <div id="order">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb :link="[{ name: 'Quản lý đơn hàng', active: true }]"></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter">
      <block :nobody="true" ref="bquota" class="soft-control">
        <control-panel
          :disabled="{
            print: true
          }"
          :countChecked="countChecked"
          @doAddNew="handleCreate"
          @doEdit="handleUpdate"
          @search="handleSearch"
          @copy="handleCopy"
          :help="handleHelp"
          @doDelete="handleDelete"
          :permission="{
            create: 'order_create',
            delete: 'order_delete'
          }"
        ></control-panel>
        <div class="row p-1">
          <div class="col-md-12">
            <b-tabs>
              <b-tab
                @click="doFilter('DANGGIAO')"
                title="Đang giao/ Chưa giao"
                :active="tabSelected === 'DANGGIAO'"
              ></b-tab>
              <b-tab @click="doFilter('ALL')" title="Tất cả" :active="tabSelected === 'ALL'"></b-tab>
              <b-tab @click="doFilter('DAGIAO')" title="Đã giao" :active="tabSelected === 'DAGIAO'"></b-tab>
              <b-tab
                @click="doFilter('DATHANHTOAN')"
                title="Đã thanh toán"
                :active="tabSelected === 'DATHANHTOAN'"
              ></b-tab>
            </b-tabs>
            <soft-table
              @rowSelected="tbSetRowSelected"
              @rowClicked="tbRowClicked"
              class="table align-items-center table-flush"
              tbody-classes="list"
              :pending="false"
              :showAll="true"
              :dataTable="tableData"
              :fields="fields"
              :minHeight="$hControl"
              ref="soft-table"
            >
              <template v-slot:cell(code)="row">
                <b-button @click="row.toggleDetails" variant="link">
                  {{ row.value }}
                </b-button>
              </template>
              <template v-slot:row-details="row">
                <div class="py-2" style="background:#fff">
                  <b-row align-h="center" class="mx-0">
                    <template v-if="row.item.status">
                      <b-button @click="invoiceCreate(row.item)" size="lg" class="mt-2" variant="success">
                        Xuất Hóa Đơn
                      </b-button>
                      <b-button
                        v-if="row.item.customer.receiptBill && row.item.customer.receiptBill.length > 0"
                        size="lg"
                        class="mt-2"
                        variant="info"
                        @click="handleAddPayment(row.item)"
                      >
                        <i class="ni ni-credit-card"></i>
                        Thanh Toán
                      </b-button>
                      <b-button v-if="row.item.success" size="lg" class="mt-2" variant="success">
                        Đã xuất đủ hàng
                      </b-button>
                      <b-button
                        v-else-if="row.item.acceptExport"
                        @click="outWarehouse(row.item)"
                        variant="info"
                        class="mt-2"
                        size="lg"
                      >
                        <i class="fa fa-paper-plane" aria-hidden="true"></i>
                        Xuất Hàng
                      </b-button>
                      <b-button v-else variant="danger" pill class="mt-2" size="lg">Vui lòng thanh toán nợ</b-button>
                    </template>
                    <template v-else>
                      <b-button @click="verifyOrder(row.item)" variant="success" class="mt-2" size="lg">
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Duyệt đơn hàng
                      </b-button>
                      <b-button @click="handleUpdate(row.item)" variant="info" class="mt-2" size="lg">
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Cập nhật đơn hàng
                      </b-button>
                    </template>
                    <b-button @click="printOrder(row.item)" variant="primary" class="mt-2" size="lg">
                      <i class="fa fa-print" aria-hidden="true"></i>
                      In đơn hàng
                    </b-button>
                    <b-button @click="fetchDataOne(row.item)" variant="secondary" class="mt-2" size="lg">
                      <i class="fa fa-sync" aria-hidden="true"></i>
                      Làm mới
                    </b-button>
                    <b-button @click="changeStatusOrder(row.item, 4)" variant="warning" class="mt-2" size="lg">
                      <i class="fa fa-sync" aria-hidden="true"></i>
                      Hoàn thành đơn hàng
                    </b-button>
                  </b-row>
                  <b-row class="mx-0 mt-2">
                    <b-col md="4">
                      <base-input v-model="row.item.userCreate.name" readonly label="Tạo bởi"> </base-input>
                    </b-col>
                    <b-col md="4">
                      <base-input
                        :value="row.item.userVerify ? row.item.userVerify.name : 'Chưa có người duyệt'"
                        readonly
                        label="Người duyệt"
                      >
                      </base-input>
                    </b-col>
                    <b-col md="4">
                      <div class="form-group has-label">
                        <label class="form-control-label">
                          Trạng thái :
                        </label>
                        <br />
                        <h3>
                          <b-badge pill v-if="row.item.status" variant="success">
                            Đã duyệt
                          </b-badge>
                          <b-badge pill v-else variant="danger">
                            Chưa được duyệt
                          </b-badge>
                        </h3>
                      </div>
                    </b-col>
                  </b-row>
                  <div class="p-2">
                    <template v-if="row.item.quota && row.item.quota.id">
                      <div class="table-responsive base-table table-soft mb-2" style="min-height:unset">
                        <table class="table tablesorter b-table b-table-no-border-collapse">
                          <thead>
                            <tr>
                              <th>Mã báo giá</th>
                              <th>Được tạo ngày</th>
                              <th>Người tạo</th>
                              <th>Người duyệt</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="text-center">
                                <b>{{ row.item.quota.code }}</b>
                              </td>
                              <td class="text-center">
                                {{ $dateTimeUnix(row.item.quota.dateCreated) }}
                              </td>
                              <td>
                                <b>{{ row.item.quota.userCreate.username }}</b>
                                <br />
                                <span>{{ row.item.quota.userCreate.name }}</span>
                              </td>
                              <td>
                                <b>{{ row.item.quota.userVerify.username }}</b>
                                <br />
                                <span>{{ row.item.quota.userVerify.name }}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </template>
                    <div class="table-responsive base-table table-soft  mb-2">
                      <table class="table tablesorter b-table b-table-no-border-collapse">
                        <thead>
                          <tr>
                            <th>Thông tin đặt hàng</th>
                            <th>Thông tin giao hàng</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style="text-align: left;">
                              <span v-if="row.item.customer.short_name">
                                <b>Tên: </b>: {{ row.item.customer.short_name }}
                              </span>
                              <span v-else>
                                <b>Tên: </b>:
                                {{ row.item.customer.name }}
                              </span>
                              <br />
                              <span>
                                <b>Đặt thù KH: </b>
                                {{ row.item.customer.fax }}
                              </span>
                              <br />
                              <!-- <span>
                                <b>Email: </b>
                                {{ row.item.customer.email }}
                              </span>
                              <br /> -->
                              <span>
                                <b>Người liên hệ:</b>
                                {{ row.item.customerContact.name }}
                              </span>
                              <br />
                              <span>
                                <b>Chức vụ:</b>
                                {{ row.item.customerContact.position }}
                              </span>
                              <br />
                              <span>
                                <b>SĐT liên hệ:</b>
                                {{ row.item.customerContact.phone }}
                              </span>
                              <br />
                            </td>
                            <td style="text-align: left;">
                              <span> <b>Tên: </b> {{ row.item.receiver.name }} </span>
                              <br />
                              <!-- <span>
                                <b>MST: </b>{{ row.item.receiver.taxCode }}
                              </span> -->
                              <span>
                                <b>Đặt thù KH: </b>
                                {{ row.item.customer.fax }}
                              </span>
                              <br />
                              <!-- <span>
                                <b>Email: </b>
                                {{ row.item.receiver.email }}
                              </span>
                              <br /> -->
                              <span>
                                <b>Người liên hệ: </b>
                                {{ row.item.receiverContact.name }}
                              </span>
                              <br />
                              <span>
                                <b>Chức vụ: </b>
                                {{ row.item.receiverContact.position }}
                              </span>
                              <br />
                              <span>
                                <b>SĐT liên hệ:</b>
                                {{ row.item.receiverContact.phone }}
                              </span>
                              <br />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="table-responsive">
                      <base-table :data="row.item.orderDetails">
                        <template slot="columns">
                          <th class="col-fix checkbox table-primary">
                            <input
                              v-model="row.item.checked"
                              @change="chooseAll(row.item, $event)"
                              type="checkbox"
                              name="checkbox"
                              class="check-input"
                            />
                          </th>
                          <th>STT</th>
                          <th>Mã sản phâm</th>
                          <th>Tên sản phẩm</th>
                          <th>Diễn giải</th>
                          <th>Quy cách</th>
                          <th>Chiều dài</th>
                          <th>Hệ màu</th>
                          <th>Màu sắc</th>
                          <th>Mã màu</th>
                          <th>Mã màu 2</th>

                          <th class="text-right">Số lượng đặt</th>
                          <th class="text-right">Số lượng đang dệt</th>
                          <th class="text-right">Số lượng tồn</th>
                          <th class="text-right">Số đã giao</th>
                          <th class="text-right">Số chưa giao</th>
                          <th class="text-right">Số đã trả lại</th>
                          <th class="text-right">Số cần giao còn lại</th>
                          <th class="text-right">Đơn giá</th>
                          <th class="text-right">Thành tiền</th>
                          <th class="text-right">Thuế</th>
                          <th class="text-right">Thành tiền sau thuế</th>
                          <th>ĐVT</th>
                          <th>Vị trí</th>
                          <th></th>
                        </template>

                        <template slot-scope="{ item, index }">
                          <tr :key="index" :style="item.totalQuantityEx >= item.quantity ? 'background:#bff4c3' : ''">
                            <td class="col-fix checkbox table-primary">
                              <input
                                v-if="item.totalQuantityEx < item.quantity"
                                v-model="item.checked"
                                @change="chooseItem(item, row.item, $event)"
                                type="checkbox"
                                name="checkbox"
                                class="check-input"
                              />
                            </td>
                            <td class="bg-info text-light col-fix">
                              {{ index + 1 }}
                            </td>
                            <td>{{ item.product.code }}</td>
                            <td>
                              {{ item.product.name }}<br />
                              <!-- {{ item.productCustom }} -->
                            </td>
                            <td class="text-center">
                              <span v-if="item.reason">{{ item.reason.name }}</span>
                            </td>
                            <td class="text-center">{{ item.productSpecify.name }}mm</td>
                            <td class="text-right">
                              <span v-if="item.length">{{ item.length }}</span>
                              <span v-else>0</span> cm
                            </td>
                            <td>
                              <div
                                v-if="item.color"
                                d-block
                                :style="'background:' + item.color.color"
                                style="border:1px solid ; color: gray; padding:0px 9px;"
                              >
                                {{ item.color.label }}
                              </div>
                            </td>
                            <td>{{ item.colorText }}</td>
                            <td>{{ item.colorCode }}</td>
                            <td>{{ item.colorCode2 }}</td>

                            <td class="text-right">
                              {{ $formatNumber(item.quantity) }}
                              {{ $ucWord(item.unit) }}
                            </td>
                            <td class="text-right">
                              {{ $formatNumber(calcQuantityInventoried(item.manufactures)) }}
                              {{ $ucWord(item.unit) }}
                            </td>
                            <td class="text-center">
                              <template v-if="item.productInfo && item.productInfo.id">
                                <span
                                  v-if="
                                    Number(item.productInfo.quantity) >= Number(item.quantity - item.totalQuantityEx)
                                  "
                                  class="text-success"
                                >
                                  {{ $formatNumber(item.productInfo.quantity) }}
                                </span>
                                <span v-else class="text-danger">
                                  {{ $formatNumber(item.productInfo.quantity) }}
                                  (thiếu hàng)
                                </span>
                              </template>
                              <b-badge v-else>Chưa sản xuất</b-badge>
                            </td>
                            <td class="text-right">
                              {{ $formatNumber(item.totalQuantityEx) }}
                              {{ $ucWord(item.unit) }}
                            </td>
                            <td class="text-right">
                              {{ $formatNumber(item.quantity - item.totalQuantityEx) }}
                              {{ $ucWord(item.unit) }}
                            </td>
                            <td class="text-right">
                              {{ $formatNumber(item.totalReturnQuantity) }}
                              {{ $ucWord(item.unit) }}
                            </td>
                            <td class="text-right">
                              {{ $formatNumber(item.quantity - item.totalQuantityEx + item.totalReturnQuantity) }}
                              {{ $ucWord(item.unit) }}
                            </td>
                            <td class="text-right">
                              {{ $formatCurrency(item.price) }}
                              {{ item.currency }} / {{ $ucWord(item.unit) }}
                            </td>
                            <td class="text-right">
                              {{ $formatCurrency(item.total) }}
                              {{ item.currency }}
                            </td>
                            <td class="text-right">
                              <span v-if="item.tax > 0"> {{ item.tax }} % </span>
                              <span v-else>
                                không thuế
                              </span>
                            </td>
                            <td class="text-right">
                              <span v-if="item.totalAmout">
                                {{ $formatCurrency(item.totalAmout) }}
                              </span>
                              {{ item.currency }}
                            </td>
                            <td>
                              <!-- <template
                              v-if="item.productInfo && item.productInfo.id"
                            >
                              <span>{{ item.productInfo.unit }}</span>
                            </template> -->
                              <b-badge>{{ item.unit }}</b-badge>
                            </td>
                            <td>
                              <template v-if="item.productInfo && item.productInfo.id">
                                <span v-html="item.productInfo.position"></span>
                              </template>
                              <span v-else>--</span>
                            </td>
                            <td>
                              <a
                                v-if="row.item.status"
                                :href="createLinkManufacture(item, row)"
                                class="btn btn-primary"
                              >
                                Lập lệnh chế tạo
                              </a>
                              <!-- <b-button
                              v-if="row.item.status"
                              @click="createManufacture(item, row)"
                              variant="primary"
                            >
                              Lập lệnh chế tạo
                            </b-button> -->
                              <b-button
                                v-if="row.item.status && item.manufactures && item.manufactures.length > 0"
                                @click="showHistoryManufaceture(item.manufactures)"
                                variant="info"
                              >
                                Lịch sử chế tạo
                              </b-button>
                            </td>
                          </tr>
                        </template>
                      </base-table>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:cell(poCode)="{ value }">
                {{ value }}
              </template>
              <template v-slot:cell(success)="{ item }">
                <div class="highlighter">
                  <div
                    class="ml-1 h"
                    :title="'Đã lập lệnh chế tạo : ' + item.countManufacture + '/' + item.orderDetails.length"
                    :class="{
                      'h-manufactures-create': item.countManufacture > 0,
                      'h-manufactures-full': item.countManufacture >= item.orderDetails.length
                    }"
                    v-if="item.countManufacture > 0"
                  ></div>
                  <div
                    :title="'Đã có sẳn hàng xuất đi : ' + item.quantityInventory"
                    class="ml-1 h h-investory-create"
                    v-if="item.quantityInventory > 0"
                  ></div>
                </div>
                <div v-if="item.success">
                  <b-progress title="Dã xuất đủ hàng" :value="100" variant="success" height="10px"></b-progress>
                </div>
                <div v-else-if="item.countEx > 0">
                  <b-progress
                    :title="'Đã xuất hàng : ' + item.sumQuantityEx + '/' + item.sumQuantity"
                    :value="(item.sumQuantityEx / item.sumQuantity) * 100"
                    variant="success"
                    height="10px"
                  ></b-progress>
                </div>
                <div v-else>
                  <b-progress title="Chưa xuất hàng" :value="0" variant="success" height="10px"></b-progress>
                </div>
              </template>
              <template v-slot:cell(customer)="{ value }">
                <div style="white-space: nowrap;">
                  MS: <b>{{ value.code }}</b> - MST: <span>{{ value.taxCode }}</span> <br />
                </div>
                Tên: <span>{{ value.name }}</span>
                <!-- MST: <span>{{ value.taxCode }}</span> <br /> -->
              </template>
              <template v-slot:cell(receiver)="{ value }">
                <div style="white-space: nowrap;">
                  MS: <b>{{ value.code }}</b> - MST: <span>{{ value.taxCode }}</span> <br />
                </div>
                Tên: <span>{{ value.name }}</span>
                <!--  <br /> -->
              </template>
              <template v-slot:cell(dateReceipt)="{ value }">
                {{ $date(value) }}
              </template>
              <template v-slot:cell(dateDelivery)="{ value }">
                {{ $date(value) }}
              </template>
              <template v-slot:cell(amount)="{ value }" th-class="text-right col-fix">
                {{ $formatNumber(value) }}
              </template>
              <template v-slot:cell(note)="{ value }">
                <div v-html="value"></div>
              </template>
              <template v-slot:cell(userCreate)="{ value }">
                <span v-if="value.id" class="badge badge-primary">{{ value.username }}</span>
              </template>
              <template v-slot:cell(userVerify)="{ value }">
                <span v-if="value.id" class="badge badge-success">{{ value.username }}</span>
                <span v-else class="badge badge-danger">
                  Chưa duyệt
                </span>
              </template>
              <template v-slot:cell(userManage)="{ value }">
                <span v-if="value.id" class="badge badge-info">{{ value.username }}</span>
                <span v-else class="badge badge-danger">
                  Chưa có hỗ trợ
                </span>
              </template>
              <template>
                <pagination
                  class="mr-2 my-1"
                  slot="footer"
                  :total="listQuery.total"
                  :perPage="listQuery.limit"
                  :value="listQuery.page"
                  @change="pagChange"
                />
              </template>
            </soft-table>
          </div>
        </div>
      </block>
      <preview ref="preview"></preview>
      <add-payment @submit:success="fetchData" ref="addPayment"></add-payment>
      <histories-manufacture ref="hisManufacture"></histories-manufacture>
      <create-invoice ref="createInvoice"></create-invoice>
    </div>
  </div>
</template>
<script>
import { orderService } from '@/_services';
import { addDate, currentUnix } from '@/utils/date';
import Preview from './__Preview';
import HistoriesManufacture from './__HistoriesManufacture';
import AddPayment from './__AddPayment';
import CreateInvoice from './__CreateInvoice';

export default {
  name: 'order-manage',
  components: {
    Preview,
    HistoriesManufacture,
    AddPayment,
    CreateInvoice
  },
  data() {
    return {
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 30,
        total: 0
      },
      lastIndexSelected: 0,
      info: {},
      allData: [],
      tableData: [],
      tableDataSelecteds: [],
      tabSelected: 'DANGGIAO',
      fields: [
        {
          variant: 'primary',
          key: 'id',
          class: 'col-fix checkbox'
        },
        {
          key: 'success',
          label: 'Trạng thái',
          sortable: true,
          class: 'col-fix'
        },
        {
          key: 'code',
          label: 'Mã đơn',
          stickyColumn: true,
          sortable: true,
          class: 'col-fix'
        },
        {
          key: 'poCode',
          label: 'STYLE NO',
          stickyColumn: true,
          sortable: true,
          class: 'col-fix'
        },
        {
          key: 'customer',
          label: 'Thông tin đặt',
          sortable: true,
          stickyColumn: true,
          class: 'col-fix'
        },
        {
          key: 'receiver',
          label: 'Thông tin giao',
          sortable: true
        },
        {
          key: 'dateReceipt',
          label: 'Ngày đặt',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'dateDelivery',
          label: 'Ngày giao',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'amount',
          label: 'Giá trị',
          sortable: true,
          class: 'text-right'
        },
        {
          tdClass: 'text-center',
          key: 'userCreate',
          label: 'N tạo',
          sortable: true
        },
        {
          tdClass: 'text-center',
          key: 'userVerify',
          label: 'N duyệt',
          sortable: true
        }
      ]
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$refs.bquota.block();
      orderService
        .findAll(this.listQuery)
        .then(res => {
          let tableData = res.data.data;
          tableData.forEach(element => {
            element.checked = false;
            let orderDetails = element.orderDetails;
            let isSuccess = true; // đã giao đủ hàng
            let countEx = 0; // Đếm phiếu xuất
            let sumQuantityEx = 0;
            let sumQuantity = 0;
            let countManufacture = 0; // Đếm phiếu chế tạo
            let quantityInventory = 0;
            orderDetails.forEach(ele => {
              ele.checked = false;
              countManufacture += ele.manufactures.length;
              if (ele.receiptBillDetails && ele.receiptBillDetails.length > 0) {
                let totalQuantity = 0;
                let totalReturnQuantity = 0;

                for (let i = 0; i < ele.receiptBillDetails.length; i++) {
                  const item = ele.receiptBillDetails[i];
                  totalQuantity += item.quantity;
                  countEx++;

                  let receiptBillReturns = item.receiptBillReturns;
                  item.countReturnQuantity = 0; // khởi tạo hàng trả lại
                  if (receiptBillReturns && receiptBillReturns.length > 0) {
                    let countReturnQuantity = 0;
                    for (let j = 0; j < receiptBillReturns.length; j++) {
                      const element = receiptBillReturns[j];
                      countReturnQuantity += element.quantity;
                    }
                    item.countReturnQuantity = countReturnQuantity;
                  }

                  totalReturnQuantity += item.countReturnQuantity;
                }
                ele.totalQuantityEx = totalQuantity; // Tổng số lượng đã xuất
                ele.totalReturnQuantity = totalReturnQuantity; // Tổng số lượng đã trả lại
                if (Math.round(ele.totalQuantityEx) < ele.quantity) {
                  isSuccess = false;
                }
              } else {
                ele.totalQuantityEx = 0;
                ele.totalReturnQuantity = 0;
                isSuccess = false;
              }

              if (ele.productInfo && ele.productInfo.id) {
                quantityInventory += ele.productInfo.quantity;
              }
              sumQuantityEx += ele.totalQuantityEx;
              sumQuantity += ele.quantity;
            });
            element.countEx = countEx;
            element.sumQuantityEx = sumQuantityEx;
            element.sumQuantity = sumQuantity;
            element.success = isSuccess;
            element.countManufacture = countManufacture;
            element.quantityInventory = quantityInventory;
            let total = 0;
            let minDateOrder = 0;
            element.historyOrder = [];
            let customerReceiptBills = element.customer.receiptBill;
            for (let i = 0; i < customerReceiptBills.length; i++) {
              const customerReceiptBill = customerReceiptBills[i];
              let receiptBillDetails = customerReceiptBill.receiptBillDetails;
              if (receiptBillDetails && receiptBillDetails.length > 0) {
                minDateOrder = receiptBillDetails[0].dateCreated;
                for (let j = 0; j < receiptBillDetails.length; j++) {
                  const item = receiptBillDetails[j];
                  element.historyOrder.push(item);
                  total += item.total;
                  if (item.dateCreated < minDateOrder) minDateOrder = item.dateCreated;
                }
              }
            }
            let current = currentUnix();
            let debtDuration = addDate(element.customer.debtDuration, minDateOrder);
            element.totalDebtAmount = total;
            if (current < debtDuration && total <= element.customer.debtAmount) {
              element.acceptExport = true;
            } else {
              element.acceptExport = false;
            }
          });

          this.allData = tableData;
          this.tableData = [...tableData];
          this.listQuery.total = res.data.total;
          this.$refs['soft-table'].selectRow(this.lastIndexSelected);
          this.doFilter(this.tabSelected);
        })
        .finally(() => {
          this.$refs.bquota.unBlock();
        });
    },
    fetchDataOne(item) {
      if (item) {
        this.info = item;
      }
      this.$refs.bquota.block();
      orderService
        .findOneSameAll(item.id)
        .then(res => {
          if (res.data) {
            let tableData = [res.data];
            tableData.forEach(element => {
              element.checked = false;
              let orderDetails = element.orderDetails;
              let isSuccess = true; // đã giao đủ hàng
              let countEx = 0; // Đếm phiếu xuất
              let sumQuantityEx = 0;
              let sumQuantity = 0;

              let countManufacture = 0; // Đếm phiếu chế tạo
              let quantityInventory = 0;
              orderDetails.forEach(ele => {
                countManufacture += ele.manufactures.length;
                ele.checked = false;
                if (ele.receiptBillDetails && ele.receiptBillDetails.length > 0) {
                  let totalQuantity = 0;
                  let totalReturnQuantity = 0;

                  for (let i = 0; i < ele.receiptBillDetails.length; i++) {
                    const item = ele.receiptBillDetails[i];
                    totalQuantity += item.quantity;
                    countEx++;

                    // Tính toán hàng trả
                    let receiptBillReturns = item.receiptBillReturns;
                    item.countReturnQuantity = 0; // khởi tạo hàng trả lại
                    if (receiptBillReturns && receiptBillReturns.length > 0) {
                      let countReturnQuantity = 0;
                      for (let j = 0; j < receiptBillReturns.length; j++) {
                        const element = receiptBillReturns[j];
                        countReturnQuantity += element.quantity;
                      }
                      item.countReturnQuantity = countReturnQuantity;
                    }
                    totalReturnQuantity += item.countReturnQuantity;
                  }
                  ele.totalQuantityEx = totalQuantity; // Tổng số lượng đã xuất
                  ele.totalReturnQuantity = totalReturnQuantity; // Tổng số lượng đã trả lại
                  if (Math.round(ele.totalQuantityEx) < ele.quantity) {
                    isSuccess = false;
                  }
                } else {
                  ele.totalQuantityEx = 0;
                  ele.totalReturnQuantity = 0;
                  isSuccess = false;
                }

                if (ele.productInfo && ele.productInfo.id) {
                  quantityInventory += ele.productInfo.quantity;
                }

                sumQuantityEx += ele.totalQuantityEx;
                sumQuantity += ele.quantity;
              });
              element.countEx = countEx;
              element.success = isSuccess;
              element.countManufacture = countManufacture;
              element.quantityInventory = quantityInventory;
              element.sumQuantityEx = sumQuantityEx;
              element.sumQuantity = sumQuantity;

              let total = 0;
              let minDateOrder = 0;
              element.historyOrder = [];
              let customerReceiptBills = element.customer.receiptBill;
              for (let i = 0; i < customerReceiptBills.length; i++) {
                const customerReceiptBill = customerReceiptBills[i];
                let receiptBillDetails = customerReceiptBill.receiptBillDetails;
                if (receiptBillDetails && receiptBillDetails.length > 0) {
                  minDateOrder = receiptBillDetails[0].dateCreated;
                  for (let j = 0; j < receiptBillDetails.length; j++) {
                    const item = receiptBillDetails[j];
                    element.historyOrder.push(item);
                    total += item.total;
                    if (item.dateCreated < minDateOrder) minDateOrder = item.dateCreated;
                  }
                }
              }
              let current = currentUnix();
              let debtDuration = addDate(element.customer.debtDuration, minDateOrder);
              element.totalDebtAmount = total;
              if (current < debtDuration && total <= element.customer.debtAmount) {
                element.acceptExport = true;
              } else {
                element.acceptExport = false;
              }
            });
            Object.assign(this.info, tableData[0]);
          }
        })
        .finally(() => {
          this.$refs.bquota.unBlock();
        });
    },
    doFilter(mode = 'DANGGIAO') {
      this.tabSelected = mode;
      if (mode == 'ALL') {
        this.tableData = [...this.allData];
      } else {
        let tableData = [];
        if (mode == 'DAGIAO') {
          this.allData.forEach(element => {
            if (
              (element.success && element.customer.receiptBill && element.customer.receiptBill.length > 0) ||
              element.status == 4
            ) {
              tableData.push(element);
            }
          });
        } else if (mode == 'DANGGIAO') {
          this.allData.forEach(element => {
            if (!element.success && element.status != 4) {
              tableData.push(element);
            }
          });
        } else if (mode == 'DATHANHTOAN') {
          this.allData.forEach(element => {
            if (element.success && (!element.customer.receiptBill || element.customer.receiptBill.length == 0)) {
              tableData.push(element);
            }
          });
        }
        this.tableData = tableData;
      }
    },
    invoiceCreate(item) {
      this.$refs.createInvoice.visible = true;
      this.$refs.createInvoice.setData(item, item.orderDetails);
    },
    calcQuantityInventoried(manufactures) {
      let quantityInventory = 0;
      for (let i = 0; i < manufactures.length; i++) {
        const element = manufactures[i];
        quantityInventory += element.quantityInventory;
      }
      return quantityInventory;
    },
    showHistoryManufaceture(manufactures) {
      this.$refs.hisManufacture.visible = true;
      this.$refs.hisManufacture.setData(manufactures);
    },
    pagChange(page) {
      this.listQuery.page = page;
      // this.tabSelected = 'ALL';
      this.fetchData();
    },
    handleSearch(keyword) {
      this.listQuery.page = 1;
      this.listQuery.search = keyword;
      this.fetchData();
    },
    tbRowClicked(item, index) {
      this.info = item;
      this.lastIndexSelected = index;
    },
    tbHandleContextMenuItemClick(a) {
      console.log('context menu', a);
    },
    handleUpdate(item) {
      if (item) {
        this.info = item;
      }
      if (this.info.status == 0) {
        this.$router.push({
          name: 'add-order',
          query: {
            edit_id: this.info.id
          }
        });
      } else {
        this.$swal({
          title: 'Chỉ có thể sửa đơn hàng chưa duyệt?',
          text: 'Đơn hàng này đã duyệt rồi không thể sửa',
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK',
          cancelButtonText: 'Không',
          reverseButtons: true
        }).then(function() {});
      }
    },
    handleCreate() {
      this.$router.push({
        name: 'add-order'
      });
    },
    chooseAll(order, $event) {
      let orderDetails = order.orderDetails;
      orderDetails.forEach(element => {
        if ($event.target.checked) {
          if (element.totalQuantityEx < element.quantity) {
            element.checked = $event.target.checked;
          }
        } else {
          element.checked = $event.target.checked;
        }
      });
    },
    chooseItem(item, order, $event) {
      item.checked = $event.target.checked;
      let countCheck = 0;
      let orderDetails = order.orderDetails;

      for (let i = 0; i < orderDetails.length; i++) {
        const element = orderDetails[i];
        if (element.checked) {
          countCheck++;
        }
      }
      if (countCheck == orderDetails.length) {
        order.checked = true;
      } else {
        order.checked = false;
      }
    },
    outWarehouse(order) {
      let orderDetails = order.orderDetails;
      let arrChoose = [];

      for (let i = 0; i < orderDetails.length; i++) {
        const element = orderDetails[i];
        if (element.checked) {
          if (element.productInfo && element.productInfo.quantity > 0) arrChoose.push(element.id);
          else {
            this.$alertify.error('Vui lòng chọn những sản phẩm có sẳn hàng', {
              duration: 4000
            });
            return;
          }
        }
      }
      if (arrChoose.length == 0) {
        this.$alertify.error('Chưa chọn sản phẩm', {
          duration: 4000
        });
      } else {
        this.$router.push({
          name: 'receipt-add-out',
          query: {
            order: order.id,
            product: arrChoose
          }
        });
      }
    },
    handleCopy() {
      this.$router.push({
        name: 'add-order',
        query: {
          copy_id: this.info.id
        }
      });
    },
    handleAddPayment(item) {
      this.$refs.addPayment.visible = true;
      this.$refs.addPayment.setData(item);
    },
    handleHelp() {
      alert('help');
    },
    handleDelete() {
      if (this.countChecked == 0) return;
      let listRemove = [];
      this.tableDataSelecteds.forEach(element => {
        listRemove.push(element.id);
      });
      this.$refs.bquota.block();
      orderService
        .removeList(listRemove)
        .then(res => {
          this.lastIndexSelected = 0;
          this.$alertify.success(res.message, {
            duration: 4000
          });
        })
        .finally(() => {
          this.fetchData();
          this.$refs.bquota.unBlock();
        });
    },
    tbSetRowSelected(items) {
      this.tableDataSelecteds = items;
      this.countChecked = items.length;
      if (items.length == 1) {
        this.info = items[0];
      }
    },
    verifyOrder(item) {
      this.$refs.bquota.block();
      orderService
        .verify(item.id)
        .then(res => {
          item.status = true;
          item.userVerify = res.data.userVerify;
          this.$alertify.success(res.message, {
            duration: 4000
          });
        })
        .finally(() => {
          this.$refs.bquota.unBlock();
        });
    },
    changeStatusOrder(item, status) {
      this.$refs.bquota.block();
      orderService
        .status(item.id, status)
        .then(res => {
          item.status = res.data.status;
          this.$alertify.success(res.message, {
            duration: 4000
          });
          this.doFilter();
        })
        .finally(() => {
          this.$refs.bquota.unBlock();
        });
    },
    sendQuotation(item) {
      alert(item);
      return;
      // this.$refs.bquota.block();
      // orderService
      //   .sendEmail(item.id)
      //   .then(res => {
      //     this.$alertify.success(res.message, {
      //       duration: 4000
      //     });
      //   })
      //   .finally(() => {
      //     this.$refs.bquota.unBlock();
      //   });
    },
    printOrder(item) {
      this.$refs.preview.visible = true;
      this.$refs.preview.setData(item, item.orderDetails);
    },
    createLinkManufacture(item, row) {
      return `/manufacture/add?order=${row.item.id}&order_detail=${item.id}`;
    },
    createManufacture(item, row) {
      let order = row.item;
      this.$router.push({
        name: 'add-manufacture',
        query: {
          order: order.id,
          order_detail: item.id
        }
      });
      // this.$router.push({
      //   name: "add-manufacture",
      //   params: {
      //     order: order,
      //     product: item.product,
      //     productSpecify: item.productSpecify,
      //     color: item.color
      //   }
      // });
    }
  }
};
</script>
<style lang="scss">
.soft-table {
  .b-table-sticky-header {
    max-height: 400px;
  }
}

#order {
  .nav-tabs {
    .nav-link {
      border-bottom: 1px solid #e8ebee;
      &.active {
        border-bottom: 1px solid #fff;
      }
    }
    margin-bottom: 4px;
  }
}
</style>
